import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';
import { glossary } from '@sorare/core/src/lib/glossary';

const Root = styled(Vertical).attrs({ gap: 2 })`
  padding: var(--double-unit);
`;

type Props = {
  open?: boolean;
  onClose?: () => void;
  validationMessages: { [key: string]: ReactNode };
};
export const LineupCancelationDialog = ({
  open,
  onClose,
  validationMessages,
}: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        <LabelL bold>
          <FormattedMessage
            id="LineupCancelationDialog.title"
            defaultMessage="{lineupsCount, plural, one {Lineup} other {Lineups}} cancelled"
            values={{ lineupsCount: validationMessages.length }}
          />
        </LabelL>
      }
    >
      <Root>
        <Vertical>
          {Object.values(validationMessages).map((warningMessage, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Vertical key={index}>{warningMessage}</Vertical>
          ))}
        </Vertical>
        <Button size="medium" color="primary" onClick={onClose}>
          <FormattedMessage {...glossary.gotIt} />
        </Button>
      </Root>
    </Dialog>
  );
};
